import { defineStore } from 'pinia';
import { getUserInfo } from '@/api/common';
import type { API } from '@/types';

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null as API.UserInfo | null,
    loading: false,
  }),
  getters: {
    isCreator: (state) => Boolean(state.userInfo?.shop_id),
  },
  actions: {
    async loadUserInfo() {
      this.loading = true;
      try {
        this.userInfo = await getUserInfo();
      } finally {
        this.loading = false;
      }
    },
    clearUserInfo() {
      this.userInfo = null;
    },
  },
});
